import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsFinanceProducts: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_FINANCE_PRODUCTS].GET_REPORTS_FINANCE_PRODUCTS,
	},
}
